<script lang="ts">
    import { _ } from "svelte-i18n"
    import ArticleSliderElement from "./ArticleSliderElement.svelte"
    let {
        type = "homepage",
        articles,
        primary_article,
        fullWidth = false,
    }: {
        type?: "homepage" | "subpage"
        articles: ArticleEntryContent[]
        primary_article?: ArticleEntryContent
        fullWidth?: boolean
    } = $props()
</script>

<div class="vertical-articles type-{type}" class:fullWidth>
    {#if primary_article}
        <div class="primary-element">
            <ArticleSliderElement entry={primary_article} isPrimary={true} />
        </div>
    {/if}

    {#if fullWidth}
        <ul class="secondaries">
            {#if articles.length > 0}
                {#each articles as secondary (secondary.id)}
                    <li>
                        <ArticleSliderElement entry={secondary} />
                    </li>
                {/each}
            {:else}
                <p>{$_("general.no-entries-found")}</p>
            {/if}
        </ul>
    {:else}
        <ul class="secondaries">
            {#if articles.length > 0}
                {#each articles as secondary (secondary.id)}
                    <li>
                        <ArticleSliderElement
                            largeDescription={type !== "homepage"}
                            disableTransitions={type == "homepage"}
                            entry={secondary}
                        />
                    </li>
                {/each}
            {:else}
                <p>{$_("general.no-entries-found")}</p>
            {/if}
        </ul>
    {/if}
</div>

<style lang="less" global>
    @import "../../../../css/variables.less";

    .vertical-articles {
        display: grid;
        max-width: var(--normal-max-width);
        gap: 2.4rem;
        position: relative;
        height: fit-content;
        width: 100%;
        grid-template-columns: 1fr;
        @media @desktop_large {
            grid-template-columns: 1fr 1fr;
        }
        &.fullWidth {
            max-width: var(--extended-max-width);
        }
        .secondaries {
            display: flex;
            flex-direction: column;
            gap: 1.2rem;
        }

        &.type-homepage {
            .footer {
                ul {
                    gap: 0px;
                }
            }
        }
        &.type-subpage .secondaries,
        .primary-element {
            position: relative;
            top: 0;
            @media @desktop_large {
                top: calc(var(--header-height) + 3rem);
                position: sticky;
            }

            width: 100%;
            height: fit-content;

            .article-preview {
                border-bottom: 0px solid black;
                @media @max-mobile {
                    height: fit-content;
                }
                .upper {
                    flex-direction: column;
                    & > .image {
                        width: 100%;
                        height: 292px;
                    }
                }
            }
            header {
                * {
                    font-size: 0.7rem !important;
                }
                .tag {
                    padding: 0.1rem 0.6rem;
                    line-height: 140%;
                    height: fit-content;
                }
            }
            footer {
                small {
                    font-size: 0.7rem !important;
                }
            }
        }
        &.type-subpage {
            display: flex;
            justify-content: space-between;
            gap: 2.4rem;
            max-width: var(--extended-max-width);

            .secondaries {
                max-width: 864px;
                width: 100%;
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 1.5rem;

                @media @max-mobile {
                    grid-template-columns: 1fr;
                    gap: 1.5rem;
                }
                .article-preview {
                    height: fit-content;
                    .image {
                        width: 100%;
                    }
                }
            }

            &.fullWidth {
                .secondaries {
                    max-width: var(--extended-max-width);
                    grid-template-columns: 1fr 1fr 1fr;
                    @media @max-tablet {
                        grid-template-columns: 1fr 1fr;
                    }
                    @media @max-mobile {
                        grid-template-columns: 1fr;
                    }
                }
            }
        }

        .primary-element {
            +.secondaries {
                li {
                .article-preview.video-card {
                    .upper {
                        .image {
                            &.video {
                                .video-overlay {
                                    display: none;
                                }
                                width: 120px;
                                height: 120px;
                                max-width: 120px;
                                max-height: 120px;
                                min-height: unset !important;
                                @media (min-width: 768px) {
                                width: 176px;
                                height: 176px;
                                max-width: 176px;
                                min-height: 176px;
                                max-height: 176px;
                                flex: 0 0 176px;
                                aspect-ratio: 1/1;
                                }
                            }
                        }
                    }
                }
            }
            }
        }
    }
</style>
